import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CredentialResponse } from '@react-oauth/google';
import { Location } from 'history';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AuthResult } from '../../services/AuthService';
import { LoginResponseLocalStorageKey } from '../../services/BackendService';
import { getItem } from '../../services/LocalStorageService';
import GoogleLogin from './GoogleLogin';
import { authState, login, setAuthResult } from './AuthSlice';
import { SliceStatus } from '../BaseState';

type LocationState = {
  from: {
    pathname: string;
    search: any;
    state?: unknown;
  };
};

const LogIn = () => {
  const [error, setError] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location: Location = useLocation();
  const state = useAppSelector(authState);

  const doLoginAndNavigate = (credentialResponse: CredentialResponse): void => {
    if (credentialResponse.credential) {
      setError(null);
      dispatch(login(credentialResponse.credential)).then(() => {
        nav();
      });
    }
  };

  const onError = () => {
    setError('An error occurred while trying to log in');
  };

  const nav = () => {
    const locationState: LocationState = location.state as LocationState;
    const pathname: string = locationState?.from?.pathname || '/users';
    const search = locationState?.from?.search;
    navigate(
      {
        pathname,
        search,
      },
      { replace: true, state: locationState?.from?.state }
    );
  };

  useEffect(() => {
    if (!state.authResult && state.status === SliceStatus.idle) {
      const authResult: AuthResult | null = getItem(LoginResponseLocalStorageKey);
      if (authResult) {
        dispatch(setAuthResult(authResult));
        nav();
      }
    }
  });

  return (
    <div className="d-flex justify-content-center">
      <div>
        <div className="p-5">
          <h2>Prerender internal site</h2>
        </div>
        {error && <div className="alert alert-danger mb-3">{error}</div>}
        <div className="d-flex justify-content-center">
          <GoogleLogin onSignIn={doLoginAndNavigate} onError={onError} />
        </div>
      </div>
    </div>
  );
};

export default LogIn;
